import { cn } from "@/lib/utils";

/**
 * UnreadDot - 7px circular indicator dot.
 *
 * Used for unread notifications, active status indicators, and "what's new" markers.
 * Always renders as a 7px circle with the given color (defaults to primary blue).
 */
export function UnreadDot({ active = true, className }: { active?: boolean; className?: string }) {
  return (
    <span
      className={cn(
        "inline-block size-[7px] shrink-0 rounded-full",
        active ? "bg-primary" : "bg-muted-foreground/40",
        className
      )}
      aria-hidden="true"
    />
  );
}
